export default "__VITE_ASSET__Bygi_3iG__"